import { render, staticRenderFns } from "./DetailOrganizationForm.vue?vue&type=template&id=8bc3f7b6&scoped=true&"
import script from "./DetailOrganizationForm.vue?vue&type=script&lang=js&"
export * from "./DetailOrganizationForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrganizationForm.vue?vue&type=style&index=0&id=8bc3f7b6&lang=less&scoped=true&"
import style1 from "./DetailOrganizationForm.vue?vue&type=style&index=1&lang=less&"
import style2 from "./DetailOrganizationForm.vue?vue&type=style&index=2&id=8bc3f7b6&lang=less&scoped=true&"
import style3 from "./DetailOrganizationForm.vue?vue&type=style&index=3&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc3f7b6",
  null
  
)

export default component.exports